// Shared KPI card used by the MIS Expense Tracker per-property view. Mirrors the
// KPI in MisExpenseStrips.jsx but with a slightly different tone-prop API (rose / emerald).
// Extracted from MisExpenses.jsx as part of the iter-35e component split.

export function KPI({ label, value, sub, accent, tone }) {
  const toneCls = tone === "rose" ? "text-rose-800" : tone === "emerald" ? "text-emerald-800" : "text-zinc-900";
  return (
    <div className="bg-zinc-50/60 border border-zinc-200 rounded-md p-2.5">
      <div className="text-[9.5px] uppercase font-bold tracking-wider text-zinc-500">{label}</div>
      <div className={`font-display font-black tabular-nums mt-1 ${toneCls}`} style={{ fontSize: 17, lineHeight: 1.4, paddingBottom: 2 }}>{value}</div>
      {sub && <div className="text-[10px] text-zinc-500 mt-0.5">{sub}</div>}
      <div className="mt-1 h-[2px] w-5 rounded-full" style={{ background: accent }} />
    </div>
  );
}
